var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-progress-circular',{class:{
      app__circular: _vm.onAppCircular
    },attrs:{"indeterminate":"","size":35,"color":_vm.circularColor,"width":_vm.circularWidth}}),_vm._v(" "),_c('div',{class:{
      'overlay--active': _vm.overlayActive,
      'background-color-default': _vm.onBackgroundColor
    }})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }